import React, { useEffect, useState } from 'react';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import axios from '../modules/axios';
import { computeParams } from '../utils';

export default ({
  resource,
  filters,
  label,
  value,
  name,
  handleChange,
  handleSubmit,
  valueAttribute,
  renderAttribute,
  renderOption,
  defaultOption,
  ...props
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const params = computeParams({ query: filters });
    axios.get(`${resource}?${params.join('&')}`).then(res => setOptions(res.data));
  }, [filters, resource]);

  return (
    <FormControl {...props}>
      <InputLabel>
        <strong>{label}</strong>
      </InputLabel>
      <Select label={label} value={value} name={name} onChange={handleChange}>
        {defaultOption && <MenuItem value={defaultOption.value}>{defaultOption.render}</MenuItem>}
        {options.map((option, index) => (
          <MenuItem key={`${resource}-${index}`} value={option[valueAttribute]}>
            {renderAttribute ? option[renderAttribute] : ''}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
